import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import {
    ManageSavedSearchSortOrders,
    savedSearchItemSortOrders,
    sellerSortOrders,
    similarItemAlertsSortOrders,
} from '@/enums';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';
import { parseQueryParams, validateQueryParams } from '@/utils/queryParams';

import ForYouPage from '../ForYouPage/ForYouPage';

type QueryParams = {
    keyword: string;
    page: string;
    pageSize: string;
    sort: string;
};

// validateQueryParams looks a sort up by key, and this enum's keys differ from its URL values.
const manageSavedSearchSorts: Record<string, string> = Object.fromEntries(
    Object.values(ManageSavedSearchSortOrders).map((sort) => [sort, sort])
);

const ForYouPageContainer = () => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const queryParams = parseQueryParams<QueryParams>(search);
    const tab = pathname.split('/')[2];
    const baseUrl = useAppSelector(getBaseUrl);

    let validatedQueryParams: ReturnType<typeof validateQueryParams>;
    if (tab === 'followed-searches') {
        validatedQueryParams = validateQueryParams(queryParams, manageSavedSearchSorts);
    } else if (tab === 'followed-auctioneers') {
        validatedQueryParams = validateQueryParams(queryParams, sellerSortOrders);
    } else if (tab === 'for-you') {
        validatedQueryParams = validateQueryParams(queryParams, savedSearchItemSortOrders);
    } else if (tab === 'similar-item-alerts') {
        validatedQueryParams = validateQueryParams(queryParams, similarItemAlertsSortOrders);
    }

    const { page, sort } = validatedQueryParams || {};

    return (
        <EnsureLoggedInContainer>
            <ForYouPage
                baseUrl={baseUrl}
                page={page}
                pageSize={queryParams.pageSize}
                pathname={pathname}
                pushNewUrl={navigate}
                search={search}
                sort={sort}
                tab={tab}
                terms={queryParams.keyword}
            />
        </EnsureLoggedInContainer>
    );
};

export default ForYouPageContainer;
